// extracted by mini-css-extract-plugin
export default {"Theme":"App_Theme__maZy5"};